import styled from 'styled-components';
import Box from '@mui/material/Box';
import ButtonBase from '@mui/material/Button';

export const Button = styled(ButtonBase).attrs({
  variant: 'contained',
  sx: { mt: 3, mb: 2, fontWeight: 700, fontSize: 16 },
})`
  background: ${({ theme }) => theme.gradients.primary};
  font-family: 'Mukta';
`;

export const ModalContainer = styled(Box).attrs({
  sx: {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: 350,
    bgcolor: 'background.paper',
    boxShadow: 24,
    borderRadius: 3,
    p: 4,
    py: 8,
  },
  justifyContent: 'center',
  display: 'flex',
})``;
